export default "__VITE_ASSET__Dtf3nJuk__"